"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenericCameraSourceSettings = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../hooks");
var _JoinComponent = require("../../Join/JoinComponent.styled");
var _MicrophoneSelector = require("../../Join/PageBody/MicrophoneSelector");
var _CheckAudioOutput = require("../../Join/PageBody/CheckAudioOutput");
var _CameraSelectorSwitch = require("../../Join/PageBody/CameraSelectorSwitch");
var _constants = require("@studio/constants");
var _GenericCameraPreview = require("../../Join/GenericCameraPreview/GenericCameraPreview");
var _PageBody = require("../../Join/PageBody/PageBody");
var _ = require("../..");
var _logger = require("@studio/logger");
var _utils = require("../../Join/utils");
var _Notification = require("../../Notification");
var _CameraSourceSettings = require("../CameraSourceSettings/CameraSourceSettings.styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LOG = new _logger.StudioLogger('generic-source-settings');

/**
 * GenericCameraSourceSettings component for configuring camera, microphone, audio output, and virtual background settings.
 *
 */
var GenericCameraSourceSettings = exports.GenericCameraSourceSettings = function GenericCameraSourceSettings(_ref) {
  var _transformedVideoInpu, _videoInputDeviceId$d, _selectedVideoInput$d;
  var _title = _ref.title,
    _description = _ref.description,
    onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel,
    audioInputDeviceId = _ref.audioInputDeviceId,
    audioOutputDeviceId = _ref.audioOutputDeviceId,
    videoInputDeviceId = _ref.videoInputDeviceId,
    _userBackground = _ref.userBackground,
    _ref$transformedVideo = _ref.transformedVideoInputs,
    _transformedVideoInputs = _ref$transformedVideo === void 0 ? [] : _ref$transformedVideo,
    clearVirtualBackground = _ref.clearVirtualBackground,
    initializeBackgroundFilter = _ref.initializeBackgroundFilter,
    getVideoInput = _ref.getVideoInput,
    switchVideoInput = _ref.switchVideoInput,
    switchAudioInput = _ref.switchAudioInput,
    currentVideoTrack = _ref.currentVideoTrack,
    client = _ref.client,
    _ref$CameraPreviewEle = _ref.CameraPreviewElement,
    CameraPreviewElement = _ref$CameraPreviewEle === void 0 ? _GenericCameraPreview.GenericCameraPreview : _ref$CameraPreviewEle,
    attendeeId = _ref.attendeeId,
    _ref$dispatch = _ref.dispatch,
    dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
    _ref$deviceActions = _ref.deviceActions,
    deviceActions = _ref$deviceActions === void 0 ? {} : _ref$deviceActions;
  var _useState = (0, _react.useState)(videoInputDeviceId),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedVideoInput = _useState2[0],
    setSelectedVideoInput = _useState2[1];
  var _useState3 = (0, _react.useState)(audioInputDeviceId),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    selectedAudioInputId = _useState4[0],
    setSelectedAudioInputId = _useState4[1];
  var _useState5 = (0, _react.useState)(audioOutputDeviceId),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    selectedAudioOutputId = _useState6[0],
    setSelectedAudioOutputId = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    isCancelInProgress = _useState8[0],
    setIsCancelInProgress = _useState8[1];
  var _useState9 = (0, _react.useState)(_description),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    description = _useState10[0],
    setDescription = _useState10[1];
  var _useState11 = (0, _react.useState)((_transformedVideoInpu = _transformedVideoInputs[0]) !== null && _transformedVideoInpu !== void 0 ? _transformedVideoInpu : null),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    transformedVideoInput = _useState12[0],
    setTransformedVideoInput = _useState12[1];
  var _useState13 = (0, _react.useState)(_userBackground),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    userBackground = _useState14[0],
    setUserBackground = _useState14[1];
  var _useNotification = (0, _hooks.useNotification)(),
    _useNotification2 = (0, _slicedToArray2["default"])(_useNotification, 2),
    notification = _useNotification2[0],
    showNotification = _useNotification2[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    isVideoDisconnected = _useState16[0],
    setIsVideoDisconnected = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
    userBackgroundLoading = _useState18[0],
    setUserBackgroundLoading = _useState18[1];
  var _useState19 = (0, _react.useState)("".concat(_title)),
    _useState20 = (0, _slicedToArray2["default"])(_useState19, 2),
    title = _useState20[0],
    setTitle = _useState20[1];
  var _getUserNameFromPrese = (0, _utils.getUserNameFromPresenterTitle)(title),
    firstName = _getUserNameFromPrese.firstName,
    lastName = _getUserNameFromPrese.lastName;
  var _useGetMediaDevices = (0, _hooks.useGetMediaDevices)({
      audio: true,
      video: true
    }),
    audioInputDevices = _useGetMediaDevices.audioInputDevices,
    audioOutputDevices = _useGetMediaDevices.audioOutputDevices,
    videoInputDevices = _useGetMediaDevices.videoInputDevices;
  (0, _react.useEffect)(function () {
    if (audioOutputDevices.length > 0) {
      var _audioOutputDevices$;
      var _selectedAudioOutputId = (_audioOutputDevices$ = audioOutputDevices[0]) === null || _audioOutputDevices$ === void 0 ? void 0 : _audioOutputDevices$.value;
      if (_selectedAudioOutputId) {
        setSelectedAudioOutputId(_selectedAudioOutputId);
      }
    }
  }, [videoInputDevices, audioInputDevices, audioOutputDevices]);
  var videoDevices = videoInputDevices;
  var audioInputDevicesList = audioInputDevices;
  var initialDeviceId = (_videoInputDeviceId$d = videoInputDeviceId === null || videoInputDeviceId === void 0 ? void 0 : videoInputDeviceId.device) !== null && _videoInputDeviceId$d !== void 0 ? _videoInputDeviceId$d : videoInputDeviceId;
  var selectedDeviceId = (_selectedVideoInput$d = selectedVideoInput === null || selectedVideoInput === void 0 ? void 0 : selectedVideoInput.device) !== null && _selectedVideoInput$d !== void 0 ? _selectedVideoInput$d : selectedVideoInput;
  var updateUserBackground = function updateUserBackground(backgroundOption) {
    return (0, _utils.handleUpdateUserBackground)(setUserBackgroundLoading, transformedVideoInput, selectedVideoInput, setUserBackground, setSelectedVideoInput, setTransformedVideoInput, backgroundOption, getVideoInput);
  };
  var updatedVideoInput = function updatedVideoInput(videoInputDevice) {
    return (0, _utils.handleUpdateVideoInput)(setUserBackgroundLoading, userBackground, transformedVideoInput, setSelectedVideoInput, setTransformedVideoInput, videoInputDevice, getVideoInput);
  };
  var hasTitle = title.trim().length > 0;
  var hasDescriptionExceededLimit = description.trim().length > 80;
  var hasFirstNameExceededLimit = firstName.trim().length > 30;
  var hasLastNameExceededLimit = lastName.trim().length > 50;
  var hasValidationError = !hasTitle || hasDescriptionExceededLimit || hasFirstNameExceededLimit || hasLastNameExceededLimit;
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(event) {
      var _transformedVideoInpu2, _transformedVideoInpu3;
      var transformedVideoInputs, videoSettingsChanged, audioSettingsChanged, videoTrack, _transformedVideoInpu4, changes;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            event.preventDefault();
            _context.next = 3;
            return (0, _utils.handleTransformedVideoInput)(userBackground, transformedVideoInput, setTransformedVideoInput, clearVirtualBackground);
          case 3:
            transformedVideoInputs = _context.sent;
            videoSettingsChanged = selectedDeviceId !== '' && (selectedDeviceId !== initialDeviceId || userBackground !== _userBackground || ((_transformedVideoInpu2 = transformedVideoInputs[0]) === null || _transformedVideoInpu2 === void 0 ? void 0 : _transformedVideoInpu2.transformedVideoTrack) !== ((_transformedVideoInpu3 = _transformedVideoInputs[0]) === null || _transformedVideoInpu3 === void 0 ? void 0 : _transformedVideoInpu3.transformedVideoTrack));
            audioSettingsChanged = selectedAudioInputId !== '' && selectedAudioInputId !== audioInputDeviceId;
            videoTrack = null;
            if (!videoSettingsChanged) {
              _context.next = 12;
              break;
            }
            _context.next = 10;
            return switchVideoInput(client, selectedDeviceId, currentVideoTrack, (_transformedVideoInpu4 = transformedVideoInputs[0]) === null || _transformedVideoInpu4 === void 0 ? void 0 : _transformedVideoInpu4.transformedVideoTrack, dispatch, deviceActions, attendeeId);
          case 10:
            videoTrack = _context.sent;
            if (videoTrack) {
              videoTrack.userBackground = userBackground;
            }
          case 12:
            if (!audioSettingsChanged) {
              _context.next = 15;
              break;
            }
            _context.next = 15;
            return switchAudioInput(client, selectedAudioInputId, dispatch, deviceActions);
          case 15:
            onSubmit({
              audioInputDeviceId: selectedAudioInputId,
              audioOutputDeviceId: selectedAudioOutputId,
              videoInputDeviceId: selectedDeviceId,
              videoInput: selectedVideoInput,
              title: title,
              description: description,
              userBackground: userBackground,
              transformedVideoInputs: transformedVideoInputs,
              videoTrack: videoTrack
            });
            changes = {};
            if (title !== _title) changes.title = title;
            if (description !== _description) changes.description = description;
            if (videoSettingsChanged) changes.videoInput = {
              deviceId: selectedDeviceId,
              background: userBackground
            };
            if (selectedAudioInputId !== audioInputDeviceId) changes.audioInput = selectedAudioInputId;
            LOG.info("CameraSourceSettings - ".concat(title, " updated settings"), changes);
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleCancel = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var _transformedVideoInpu5, usingDefaultBackground, transformedInput, shouldRestoreTransformedTrack, videoTrack, _transformedInput$dev, _restoredTransformedI, restoredTransformedInput;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setIsCancelInProgress(true);
            _context2.prev = 1;
            usingDefaultBackground = _userBackground === _constants.BACKGROUND_OPTIONS.NONE;
            transformedInput = (_transformedVideoInpu5 = _transformedVideoInputs[0]) !== null && _transformedVideoInpu5 !== void 0 ? _transformedVideoInpu5 : null;
            shouldRestoreTransformedTrack = !usingDefaultBackground && transformedInput !== null;
            videoTrack = null;
            if (!usingDefaultBackground) {
              _context2.next = 9;
              break;
            }
            _context2.next = 9;
            return clearVirtualBackground();
          case 9:
            if (!shouldRestoreTransformedTrack) {
              _context2.next = 19;
              break;
            }
            if (!((transformedInput === null || transformedInput === void 0 ? void 0 : transformedInput.transformedVideoTrack) != null)) {
              _context2.next = 14;
              break;
            }
            _context2.t0 = transformedInput;
            _context2.next = 17;
            break;
          case 14:
            _context2.next = 16;
            return getVideoInput(_userBackground, null, (_transformedInput$dev = transformedInput === null || transformedInput === void 0 ? void 0 : transformedInput.device) !== null && _transformedInput$dev !== void 0 ? _transformedInput$dev : videoInputDeviceId, setTransformedVideoInput);
          case 16:
            _context2.t0 = _context2.sent;
          case 17:
            restoredTransformedInput = _context2.t0;
            videoTrack = (_restoredTransformedI = restoredTransformedInput === null || restoredTransformedInput === void 0 ? void 0 : restoredTransformedInput.transformedVideoTrack) !== null && _restoredTransformedI !== void 0 ? _restoredTransformedI : null;
          case 19:
            _context2.next = 21;
            return onCancel({
              transformedVideoInputs: _transformedVideoInputs,
              videoInput: shouldRestoreTransformedTrack ? transformedInput : videoInputDeviceId,
              videoTrack: videoTrack
            });
          case 21:
            _context2.prev = 21;
            setIsCancelInProgress(false);
            return _context2.finish(21);
          case 24:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1,, 21, 24]]);
    }));
    return function handleCancel() {
      return _ref3.apply(this, arguments);
    };
  }();
  var isCancelDisabled = isCancelInProgress || isVideoDisconnected || userBackgroundLoading;
  var isSubmitDisabled = hasValidationError || isCancelInProgress || userBackgroundLoading;
  var disableInput = false;
  var disableVideoInput = userBackgroundLoading || disableInput;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_CameraSourceSettings.NotificationComponentWrapper, null, notification.message !== '' && /*#__PURE__*/_react["default"].createElement(_Notification.Notification, (0, _extends2["default"])({
    key: notification.id
  }, notification))), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardBody, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardTitleContainer, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardTitle, {
    tag: "h4"
  }, "Settings")), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledSettingsComponentContent, null, /*#__PURE__*/_react["default"].createElement(_PageBody.PageBody, {
    presenterTitle: title,
    presenterDescription: description,
    setPresenterTitle: setTitle,
    setPresenterDescription: setDescription,
    microphoneSelector: /*#__PURE__*/_react["default"].createElement(_MicrophoneSelector.MicrophoneSelector, {
      selectedAudioInputDevice: selectedAudioInputId,
      audioInputDevices: audioInputDevicesList,
      onMicrophoneChange: setSelectedAudioInputId,
      disabled: disableInput
    }),
    checkAudioOutput: /*#__PURE__*/_react["default"].createElement(_CheckAudioOutput.CheckAudioOutput, {
      audioOutputDevice: selectedAudioOutputId,
      disabled: disableInput
    }),
    cameraSelector: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_CameraSelectorSwitch.CameraSelectorSwitch, {
      selectedVideoInput: selectedVideoInput,
      videoInputDevices: videoDevices,
      onCameraChange: updatedVideoInput,
      disabled: disableVideoInput,
      userBackground: userBackground,
      setUserBackground: updateUserBackground,
      initializeBackgroundFilter: initializeBackgroundFilter,
      setIsVideoDisconnected: setIsVideoDisconnected
    })),
    cameraPreview: /*#__PURE__*/_react["default"].createElement(CameraPreviewElement, {
      presenterTitle: title,
      presenterDescription: description,
      videoInputDevice: userBackground !== _constants.BACKGROUND_OPTIONS.NONE ? transformedVideoInput : selectedVideoInput
    }),
    checkStatus: "READY",
    readinessCheck: {}
  })), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardFooter, null, /*#__PURE__*/_react["default"].createElement(_.Button, {
    onClick: handleCancel,
    color: "outline",
    className: "me-2",
    "data-testid": "cancel",
    disabled: isCancelDisabled
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_.Button, {
    disabled: isSubmitDisabled,
    onClick: handleSubmit,
    color: "primary",
    "data-testid": "submit"
  }, "Done"))));
};
GenericCameraSourceSettings.propTypes = {
  title: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func.isRequired,
  audioInputDeviceId: _propTypes["default"].string,
  audioOutputDeviceId: _propTypes["default"].string,
  videoInputDeviceId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  userBackground: _propTypes["default"].oneOf([_constants.BACKGROUND_OPTIONS.NONE, _constants.BACKGROUND_OPTIONS.BLUR, _constants.BACKGROUND_OPTIONS.CUSTOM]),
  transformedVideoInputs: _propTypes["default"].array,
  clearVirtualBackground: _propTypes["default"].func.isRequired,
  initializeBackgroundFilter: _propTypes["default"].func.isRequired,
  getVideoInput: _propTypes["default"].func.isRequired,
  switchVideoInput: _propTypes["default"].func.isRequired,
  switchAudioInput: _propTypes["default"].func.isRequired,
  currentVideoTrack: _propTypes["default"].object,
  client: _propTypes["default"].object.isRequired,
  CameraPreviewElement: _propTypes["default"].elementType,
  attendeeId: _propTypes["default"].string,
  dispatch: _propTypes["default"].func,
  deviceActions: _propTypes["default"].object
};